module.exports = __webpack_public_path__ + "img/developer-bigger.959da3fd.png";